import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'numberAbbrev'
})
export class NumberAbbrevPipe implements PipeTransform {
    private fmt = new Intl.NumberFormat('en', { notation: 'compact', maximumFractionDigits: 1 });

    transform(value: number | null | undefined): string {
        if (value == null) return '';

        return this.fmt.format(value).replace('K', 'k');
    }
}
